import { render, staticRenderFns } from "./RegisterSensor.vue?vue&type=template&id=22df36e1&scoped=true"
import script from "./RegisterSensor.vue?vue&type=script&lang=js"
export * from "./RegisterSensor.vue?vue&type=script&lang=js"
import style0 from "./RegisterSensor.vue?vue&type=style&index=0&id=22df36e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22df36e1",
  null
  
)

export default component.exports